import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import OpportunitiesDesktop from "./OpportunitiesDesktop";

function Opportunities({ app, config }) {
  return <OpportunitiesDesktop app={app} config={config} />;
}

Opportunities.defaultProps = {
  app: null,
  config: {},
};

Opportunities.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Opportunities;
